import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../components/auth/AuthContext';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Box,
} from '@mui/material';
import axios from 'axios';

const AllTeachers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { schoolId: contextSchoolId } = useAuth();
  const schoolId = location.state?.schoolId || contextSchoolId;

  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/teachers', {
          params: { schoolId },
        });
        setTeachers(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching teachers:', error);
        setLoading(false);
      }
    };

    if (schoolId) fetchTeachers();
  }, [schoolId]);

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.02, transition: { duration: 0.2 } },
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 3 }}>
          All Teachers
        </Typography>
        <Grid container spacing={2}>
          {teachers.map((teacher) => (
            <Grid item xs={12} sm={6} md={4} key={teacher._id}>
              <motion.div variants={cardVariants} initial="hidden" animate="visible" whileHover="hover">
                <Card
                  sx={{ p: 2, boxShadow: 3, bgcolor: '#fff', cursor: 'pointer' }}
                  onClick={() => navigate('/teacher-details', { state: { teacher } })}
                >
                  <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333', mb: 1 }}>
                      {teacher.fullName}
                    </Typography>
                    <Typography sx={{ color: '#666' }}>TSC Number: {teacher.tscNumber}</Typography>
                    <Typography sx={{ color: '#666' }}>Phone: {teacher.phoneNumber}</Typography>
                    <Typography sx={{ color: '#666' }}>Subject: {teacher.subjectSpecialization}</Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Container>
  );
};

export default AllTeachers;